<template>
  <div class="assign-reporting-entity-form bg-white px-4 py-5 border-b border-gray-200 sm:px-6">
    <div class="-ml-4 -mt-4 flex justify-between items-center flex-wrap sm:flex-nowrap">
      <div class="ml-4 mt-4">
        <h3 class="text-lg leading-6 font-medium text-gray-900">
          Assign to an Allocated Group
        </h3>
      </div>
    </div>
    <div class="modal-body">
      <div class="mt-1 text-sm leading-5 text-gray-500" v-if="existingMemberships">
        The {{ modelPrettified }}s below have existing allocated group memberships
        <div class="mt-4 pl-6">
        <div v-for="item, key in memberships" v-bind:key="key" class=" mb-2">
          <a v-bind:href="`${pathToModel}/${key}`" target="_blank" class=" text-blue-600 focus:underline focus:outline-0 hover:text-blue-400"> {{ item }} </a>
        </div>
        </div>
        <div class="action-buttons">
          <button type="button" class="btn btn-danger" @click="cancel">Cancel</button>
          <button type="button" class="btn btn-primary" @click="existingMembershipsOk">Continue</button>
        </div>
      </div>
      <div v-else>
        <p class="mt-1 mb-2 text-sm leading-5 text-gray-500">
          All of the {{ modelPrettified }}s that have been selected will be assigned to the allocated group of your choice.
        </p>
        <multiselect v-if="entitiesLoaded"
          v-model="selectedEntity"
          :options="entities"
          label="name"
          track-by="id"
          placeholder="Select Allocated Group"
          :show-labels="false"
          :multiple="false"
        />
        <div class="action-buttons">
          <button type="button" class="btn btn-danger" @click="close()">Cancel</button>
          <button type="button" class="btn btn-primary" @click="submit" :disabled="!selectedEntity">Submit</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import { startCase } from 'lodash-es'
  import Multiselect from 'vue-multiselect'
  import BulkActionService from '@services/BulkActionService'
  import FlashMessages from '@services/FlashMessages'

  export default {
    name: 'assign-reporting-entities-form',
    components: {
      Multiselect,
    },
    data () {
      return {
        entities: [],
        entitiesLoaded: false,
        existingMemberships: false,
        memberships: {},
        selectedEntity: null,
        processing: false,
      }
    },
    computed: {
      modelPrettified () {
        return startCase(this.model)
      },
      pathToModel () {
        switch (this.model) {
          case 'TrainingCenter': return 'training_centers'
          case 'TrainingCenterGroup': return 'training_center_groups'
          default: return null
        }
      }
    },
    methods: {
      requestReportingEntities () {
        axios.get('/reporting_entities.json')
          .then(rep => {
            this.entities = rep.data
            this.entitiesLoaded = true
          })
      },
      checkForExistingMemberships () {
        const allMembers = window.gon["memberships"]
        const keys =Object.keys(allMembers)
        console.log(keys)
        console.log(this.ids)
        const filteredKeys = this.ids.filter(value => keys.includes(String(value)))
        console.log(filteredKeys)
        filteredKeys.forEach(key => { this.memberships[key] = allMembers[key] })
        if (Object.keys(this.memberships).length > 0) {
          this.existingMemberships = true
        }
      },
      existingMembershipsOk () {
        this.existingMemberships = false
      },
      cancel () {
        this.$emit('cancel')
      },
      close () {
        this.$emit('close')
      },
      submit () {
        if (!this.processing) {
          this.processing = true
          BulkActionService.assignReportingEntity(this.ids, this.model, this.selectedEntity.id)
            .then(resp => {
              FlashMessages.success(`${resp.data.result} record(s) assigned to the ${this.selectedEntity.name} Allocated Group`, 'Success')
              this.close()
            })
            .catch(resp => {
              FlashMessages.error(`Failed to assign Allocated Group. Please try again later.`, 'Error')
              this.close()
            })
        }
      },
    },
    created () {
      this.checkForExistingMemberships()
      this.requestReportingEntities()
    },
    props: {
      ids: {
        type: Array,
        required: true,
      },
      model: {
        type: String,
        required: true,
      },
    },
  }
</script>

<style lang="scss">
  .assign-reporting-entity-form {
    .modal-body {
      margin-top: 15px;

      .action-buttons {
        margin-top: 15px;
        display: flex;
        justify-content: space-between;
      }
    }
  }
</style>
